import React from 'react'

import { Item1 } from './Item1'
import { Item2 } from './Item2'
import { Item3 } from './Item3'

export default [<Item1 />, <Item2 />, <Item3 />]



// WEBPACK FOOTER //
// src/components/Carousel/Items/index.js